var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.count >= 2
    ? _c("section", { staticClass: "content-block lg:pb-3" }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "vlx-container gap-0 lg:hidden text-center" },
            [
              _c("h2", [_vm._t("heading")], 2),
              _vm._v(" "),
              _c("div", { staticClass: "text-editor" }, [_vm._t("body")], 2)
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "aspect-w-16 aspect-h-9 sm:aspect-w-18 sm:aspect-h-6"
            },
            _vm._l(_vm.images, function(img, index) {
              return _c(
                "div",
                { key: index },
                [
                  index === 0
                    ? [
                        _c("img", {
                          staticClass:
                            "lazy w-full h-full object-cover hidden lg:block z-10",
                          attrs: { src: img.desktop, alt: "image" }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass:
                            "lazy w-full h-full object-cover lg:hidden z-10",
                          attrs: { src: img.mobile, alt: "image" }
                        })
                      ]
                    : [
                        _c("img", {
                          staticClass:
                            "lazy w-full h-full object-cover hidden lg:block z-10 transition-opacity duration-500",
                          style: "opacity: " + _vm.calculateValue(index),
                          attrs: { src: img.desktop, alt: "image" }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass:
                            "lazy w-full h-full object-cover lg:hidden z-10 transition-opacity duration-500",
                          style: "opacity: " + _vm.calculateValue(index),
                          attrs: { src: img.mobile, alt: "image" }
                        })
                      ]
                ],
                2
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "sm:max-w-md sm:mx-auto lg:flex lg:transform lg:justify-between lg:-translate-y-1/3 lg:top-1/3 lg:bg-velux-white lg:max-w-screen-lg lg:text-velux-grey-900 z-20 relative lg:shadow-md"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "hidden lg:flex lg:flex-wrap lg:flex-col lg:w-full lg:pr-6 lg:py-6 lg:pl-12 lg:-ml-1"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "text-3xl font-normal mb-3",
                      attrs: { role: "heading", "aria-level": "2" }
                    },
                    [_vm._t("heading")],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-editor" }, [_vm._t("body")], 2)
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "px-2 lg:px-0" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "mx-auto relative transform lg:transform-none -translate-y-1/2 top-1/2 lg:flex lg:items-center lg:content-center lg:flex-wrap lg:top-0 bg-velux-grey-900 px-20 py-3 sm:py-6 lg:py-7 z-20 lg:mr-0 text-center max-w-sm h-full"
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass:
                          "text-velux-white sm:mb-4 lg:mb-3 block min-w-full",
                        attrs: { for: "range-before-after" }
                      },
                      [_vm._t("label")],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "relative flex items-center w-full" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "absolute h-2 rounded-lg overflow-hidden absolute -left-8 -right-8 transform -translate-y-1/2 top-1/2 bg-velux-white min-w-full flex justify-between"
                          },
                          [
                            _c("div", {
                              staticClass: "w-8",
                              attrs: { role: "button" },
                              on: { click: _vm.jumpToMin }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "w-8",
                              attrs: { role: "button" },
                              on: { click: _vm.jumpToMax }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.rangeValue,
                              expression: "rangeValue"
                            }
                          ],
                          ref: "rangeSlider",
                          staticClass:
                            "w-full lg:w-64 h-8 opacity-0 appearance-none cursor-pointer",
                          attrs: {
                            id: "range-before-after",
                            type: "range",
                            step: 100 / (_vm.images.length - 1),
                            min: "0",
                            max: "100"
                          },
                          domProps: { value: _vm.rangeValue },
                          on: {
                            __r: function($event) {
                              _vm.rangeValue = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass:
                            "w-full lg:w-64 h-2 rounded-lg overflow-hidden absolute left-0 right-0 transform -translate-y-1/2 top-1/2 bg-velux-white pointer-events-none"
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-velux-red w-16 h-8 rounded-full inline-flex items-center justify-center absolute transform -translate-y-1/2 top-1/2 -translate-x-8 cursor-pointer z-0 pointer-events-none shadow-md transition-all",
                            style: "left: " + _vm.rangeValue + "%",
                            attrs: { role: "slider", tabindex: "0" }
                          },
                          [_vm._m(0)]
                        )
                      ]
                    )
                  ]
                )
              ])
            ]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "grid gap-2 text-sm grid-cols-2 text-velux-white items-center"
      },
      [
        _c("i", {
          staticClass: "far fa-chevron-down transform rotate-90 mx-1-5"
        }),
        _vm._v(" "),
        _c("i", {
          staticClass: "far fa-chevron-down transform -rotate-90 mx-1-5"
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }